import React from 'react'

import { NavLink } from 'react-router-dom'

import { List, ListItem, ListItemText, useTheme } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const FacilityBookingNav = (props) => {
	const { selectedFacility, location } = props
	const classes = useStyles()

	let ourPath = 'daycare'
	if (location?.pathname?.includes('boarding')) ourPath = 'boarding'
	if (location?.pathname?.includes('compatibility')) ourPath = 'compatibility'
	if (location?.pathname?.includes('grooming')) ourPath = 'grooming'

	return (
		<List className={classes.defaultNav}>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/facilityBooking/${ourPath}/booking`}>
				<ListItemText primary="Booking" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${
					selectedFacility ? selectedFacility._id : null
				}/facilityBooking/${ourPath}/cancellation`}>
				<ListItemText primary="Cancellation" />
			</ListItem>
		</List>
	)
}

export default FacilityBookingNav
